import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiClient } from '../../services/apiClient'
import './DebugPanel.css'

const DebugPanel = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<string>('')
  const [isCollapsed, setIsCollapsed] = useState(true)

  const handleCreateSubscription = async () => {
    setLoading(true)
    setResult('')
    try {
      const today = new Date()
      const endDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) // 30 дней

      const response = await apiClient.createSubscription({
        subscription_type: 'premium',
        subscription_start: today.toISOString().split('T')[0], // YYYY-MM-DD
        subscription_end: endDate.toISOString().split('T')[0], // YYYY-MM-DD
      })
      setResult(`✅ Подписка создана: ${JSON.stringify(response, null, 2)}`)
    } catch (error: any) {
      setResult(`❌ Ошибка создания: ${error.message}`)
      console.error('Ошибка создания подписки:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteSubscription = async () => {
    setLoading(true)
    setResult('')
    try {
      const response = await apiClient.deleteSubscription()
      setResult(`✅ Подписка удалена: ${JSON.stringify(response, null, 2)}`)
    } catch (error: any) {
      setResult(`❌ Ошибка удаления: ${error.message}`)
      console.error('Ошибка удаления подписки:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleTestVideo = () => {
    navigate('/test-video')
  }

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <div className={`debug-panel ${isCollapsed ? 'collapsed' : 'expanded'}`}>
      <div className="debug-header" onClick={toggleCollapse}>
        <h3>🛠️ Debug Panel</h3>
        <button className="collapse-btn">{isCollapsed ? '▼' : '▲'}</button>
      </div>

      {!isCollapsed && (
        <div className="debug-content">
          <div className="debug-buttons">
            <button
              onClick={handleCreateSubscription}
              disabled={loading}
              className="debug-btn create-btn"
            >
              {loading ? '⏳' : '➕'} Создать подписку
            </button>
            <button
              onClick={handleDeleteSubscription}
              disabled={loading}
              className="debug-btn delete-btn"
            >
              {loading ? '⏳' : '🗑️'} Удалить подписку
            </button>
            <button onClick={handleTestVideo} className="debug-btn test-btn">
              🎥 Тест видео
            </button>
          </div>
          {result && (
            <div className="debug-result">
              <pre>{result}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default DebugPanel
